'use es6';

import { getRequestStatus } from './RequestStatusSelectors';
export const getUsersInfo = state => state.usersInfo;
export const getUsersInfoRequestStatus = getRequestStatus('usersInfo');
export const getTeamsInfo = state => state.teamsInfo;
export const getTeamsInfoRequestStatus = getRequestStatus('teamsInfo');